import { createSelector } from 'reselect';
import { FOCUS_COUNTER_KEY } from '../../constants';
import insurancePickerSelector from '../insurancePickerSelector';

const getFocusCounter = createSelector(
    insurancePickerSelector,
    insurance => insurance[FOCUS_COUNTER_KEY]
);

export {
    getFocusCounter as default,
    getFocusCounter,
};
